export function handleInterstitial(topAdContainer: Element | null, open: boolean): void {
  const adClass = 'interstitial';
  const hideScrollingClass = 'hideScrolling';

  if (open) {
    topAdContainer?.classList.add(adClass);
    document.documentElement.classList.add(hideScrollingClass);
  } else {
    topAdContainer?.classList.remove(adClass);
    document.documentElement.classList.remove(hideScrollingClass);
  }
}
